export const signInCopyEn = {
  user: {
    eyebrow: 'Plan your trips',
    title: 'Welcome back',
    subtitle:
      'Sign in to manage your trips, day-by-day plans, and city options. Everything you need to organize travel in one place.',
    sessionExpiredSubtitle: 'Your session has expired. Sign in to return to the page you were viewing.',
    cta: 'Sign In',
    benefits: [
      'Create and manage your trips',
      'Build day-by-day itineraries',
      'Keep per-city options and ideas organized',
    ] as const,
    alternateLink: 'Travel professional? Sign in here',
  },
  pro: {
    eyebrow: 'For Travel Professionals',
    title: 'Welcome back',
    subtitle:
      'Sign in to access your client trips, itineraries, and list builder. Everything you need to plan and manage travel in one place.',
    sessionExpiredSubtitle: 'Your session has expired. Sign in to return to the page you were viewing.',
    cta: 'Sign In',
    benefits: [
      'Manage clients and itineraries',
      'Build day-by-day trip plans',
      'Share PDFs and keep options organized',
    ] as const,
    alternateLink: 'Looking for personal trip planning?',
  },
} as const;
